import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { type InvoiceProgressFilterType, type InvoiceProgressFilterOption, getOption, InvoiceProgressOptions, initialInvoiceProgressFilter } from "./FilterTypes/InvoiceProgressFilterType";
import { FilterContext } from "../FilterContext";

export const DefaultInvoiceProgressFilter: server.dto.InvoiceLifeCycleFilterOptions = "unknown";

const InvoiceProgressFilter = () => {
  const title = RESX.Document.Progress;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  const reset = (): InvoiceProgressFilterType => ({
    option: getOption(DefaultInvoiceProgressFilter)
  });
  register("invoiceProgress", {
    getTitle: () => title,
    renderSelection: (value) => <>{value.option.label}</>,
    hasValue: (value) => value.option.value !== DefaultInvoiceProgressFilter,
    reset,
    areEqual: (a, b) => a.option.value === b.option.value
  });
  useEffect(() => {
    setInitialValue("invoiceProgress", reset());
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedOption, setSelectedOption] = React.useState(initialInvoiceProgressFilter.option);

  const onChange = (option: InvoiceProgressFilterOption) => {
    if (selectedOption?.value === option.value) {
      setValue("invoiceProgress", reset());
      setSelectedOption(undefined);
    } else {
      setSelectedOption(option);
      setValue("invoiceProgress", { option });
    }
    onPopupClose();
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedOption(getValue("invoiceProgress").option);
    setPopupOpen(true);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<div>
        <SelectableList
          noSearch
          items={InvoiceProgressOptions}
          selectedItems={selectedOption ? [selectedOption] : []}
          onItemToggled={onChange}
          getId={opt => opt.value}
          getName={opt => opt.label}
        />
      </div>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default InvoiceProgressFilter;